import React, { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import Label from './Label';
import useCheckoutState from '../../../hooks/useCheckoutState';
import emailSpellChecker from '../../../lib/emailSpellChecker';
import TextInput from '../../Form/components/TextInput/TextInput';

export default function EmailField({ field, onChange }) {
  const { checkout } = useCheckoutState();
  const { label } = field;
  const [emailSuggestion, setEmailSuggestion] = useState(null);
  const [isFocused, setIsFocused] = useState(false);

  // debounce validation
  const debouncedValidate = React.useCallback(
    debounce(emailInput => {
      const suggestion = emailSpellChecker(emailInput);

      if (suggestion) {
        setEmailSuggestion(suggestion);
      } else {
        setEmailSuggestion(null);
      }
    }, 500),
    [],
  );

  useEffect(() => {
    if (!field.value) return;

    debouncedValidate(field.value);
  }, [field.value, isFocused]);

  return (
    <>
      {label.length > 0 && (
        <Label htmlFor={field._id} className="cp_form-label" required={field.required}>
          {label}
        </Label>
      )}

      <TextInput
        id={field._id}
        name={field._id}
        type="email"
        placeholder={field.placeholder || label}
        value={field.value}
        onChange={e => onChange(e.target.value)}
        required={field.required}
        className="cp_form-textinput"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />

      {emailSuggestion && (
        <p className="cp_form-suggestion mt-2 text-sm text-right">
          {checkout.emailSuggestionText}{' '}
          <button
            onClick={() => {
              onChange(emailSuggestion);
              setEmailSuggestion(null);
            }}
            className="cp_form-suggestion-button font-medium underline"
            type="button"
          >
            {emailSuggestion}
          </button>
          ?
        </p>
      )}
    </>
  );
}
